import type { Guide, GuideRecordHint } from '../types';

/** S-20.10-10 — kopia prezlecenia z porównaniem pól (scenariusz e2e 15, ścieżki ADM-03, ADM-10). */
const PRE_ORDER: GuideRecordHint = {
  description: 'prezlecenie, które chcesz skopiować (np. stałe zlecenie klienta)',
  listPath: '/pre-orders',
};

export const guide: Guide = {
  flagKey: 'preOrderCopy',
  title: 'Kopia prezlecenia z porównaniem pól',
  whatItDoes:
    '„Kopiuj” na prezleceniu otwiera porównanie pole po polu: wartość źródła, wartość kopii i decyzja przy każdym polu — zostaw, zmień albo wyczyść. Daty i numer zamówienia klienta wymagają jawnej decyzji; numer nie przechodzi na kopię sam. Kopia powstaje dopiero po decyzjach, jako zwykłe prezlecenie do akceptacji, ze śladem „skopiowane z” w historii obu prezleceń.',
  audience: ['CS', 'Administracja'],
  presentationItems: ['S-20.10-10'],
  steps: [
    {
      route: '/pre-orders/:preOrderId/copy',
      record: PRE_ORDER,
      target: 'copy-row-*',
      mockupTestId: 'adm-kopia-porownanie-zgodne',
      title: 'Porównanie pole po polu',
      description:
        'Wiersz na każde pole: wartość ze źródła, wartość na kopii i decyzja. Pola „do potwierdzenia” (daty, numer zamówienia klienta) czekają na Twój wybór.',
      action: 'Na karcie prezlecenia kliknij „Kopiuj” i przy każdym polu wybierz: zostaw, zmień albo wyczyść.',
      recorder: { account: 'admin', demo: { kind: 'scenario', key: 'preOrderId' } },
    },
    {
      route: '/pre-orders/:preOrderId/copy',
      record: PRE_ORDER,
      target: 'copy-missing',
      mockupTestId: 'adm-kopia-utworz',
      title: 'Kopia dopiero po decyzjach',
      description:
        '„Utwórz kopię” jest nieaktywne, dopóki przy którymś polu brakuje decyzji — lista mówi, przy których. Nowy numer zamówienia klienta wpisujesz albo zostawiasz pusty.',
      action: 'Uzupełnij decyzje z listy i kliknij „Utwórz kopię”.',
      recorder: { account: 'admin', demo: { kind: 'scenario', key: 'preOrderId' } },
    },
  ],
};
